export const CustomFieldConstant = {
	GET_LIST: 'GET_CUSTOMFIELDLIST',
	GET: 'GET_CUSTOMFIELD',
	CREATE: 'CREATE_CUSTOMFIELD',
	UPDATE: 'UPDATE_CUSTOMFIELD',
	DELETE: 'DELETE_CUSTOMFIELD',
	ADDUPDATE: 'CUSTOMFIELD_ADDUPDATE',
    LOADING: 'CUSTOMFIELD_LOADING',
    LOADED: 'CUSTOMFIELD_LOADED',
};